import { create } from 'zustand'

import { setUserParam as setUserParamApi } from '../../gateways/api'

export { useUserParam }

const useUserParam = () => {
  const userParam = useStore((state) => state.userParam)
  const storeUserParam = useStore((state) => state.storeUserParam)

  return { userParam, storeUserParam }
}

const useStore = create<{
  userParam: string
  storeUserParam: (userParam: string) => void
}>((set) => ({
  userParam: '',
  storeUserParam: (userParam) => {
    setUserParamApi(userParam)
    set(() => ({ userParam }))
  },
}))
